import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import { Container } from 'react-bootstrap';
import axios from 'axios';

const Complains = () => {
  const [complaints, setComplaints] = useState([]);

  useEffect(() => {
    axios.get('https://backend.writerswright.com/api/v1/admin/getComplaints')
      .then(response => {
        setComplaints(response.data.essayResults);
      })
      .catch(error => {
        console.error('Error fetching complaints:', error);
      });
  }, []);

  return (
    <Container>
      <h4 className="titleone">
        Complains
      </h4>
      <div className='tables'>
        <Table bordered>
          <thead>
            <tr>
              <th style={{color:"var(--primary)",fontWeight:"bold"}} className='text'>Sr</th>
              <th style={{color:"var(--primary)",fontWeight:"bold"}} className='text'>Essay Title</th>
              <th style={{color:"var(--primary)",fontWeight:"bold"}} className='text'>Due Date</th>
              <th style={{color:"var(--primary)",fontWeight:"bold"}} className='text'>Student</th>
              <th style={{color:"var(--primary)",fontWeight:"bold"}} className='text'>Complain Details</th>
            </tr>
          </thead>
          <tbody>
            {complaints.map((complaint, index) => (
              <tr key={complaint.Id}>
                <td>{index + 1}</td>
                <td>{complaint.Title}</td>
                <td>{new Date(complaint.deadline).toLocaleString()}</td>
                <td>{`${complaint.Name} ${complaint.Surname}`}</td>
                <td>{complaint.complainDetails}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Container>
  );
}

export default Complains;
